module.exports = __webpack_public_path__ + "static/media/s0 — kopia.dced3671.jpg";